import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import patientChange from '@/views/mainMenu/patientChange.vue';
import esHealthProSearch from '@/views/patientMain/dashbAdmin/relationShip/esHealthProSearch.vue';

import { ref } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useI18n } from "vue-i18n";
import officeapi from "@/api/officeapi";
import {toastError} from "@/utils/toast-utils";
import {useToast} from "primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'docRecipientsAddOn',
  emits: ['reload'],
  setup(__props, { emit: __emit }) {

const toast = useToast();
const currentEntryStore = useCurrentEntryStore()
const { t } = useI18n();
const emit = __emit;
const dropd = ref(null);

async function addPwrPersonToPwrPatient(pwr) {
  dropd.value = '';
  const pwrPersonId = pwr.patientId;
  const pwrPatientId = currentEntryStore.currentPatient.personWithRoleId;
  try {
    await officeapi.addPwrPersonToPwrPatient(pwrPatientId, pwrPersonId);
  } catch (error: any) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
  emit('reload');
}

async function reload() {
  dropd.value = ''
  emit('reload');
}


return (_ctx: any,_cache: any) => {
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_dropdownBox, {
      modelValue: dropd.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
      openOn: "AddPrivatePatient"
    }, {
      dropd: _withCtx(() => [
        _createVNode(patientChange, {
          "exclude-patients": [_unref(currentEntryStore).currentPatientId],
          onSelectedPatient: addPwrPersonToPwrPatient
        }, null, 8, ["exclude-patients"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_dropdownBox, {
      modelValue: dropd.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
      openOn: "AddHealthPro"
    }, {
      dropd: _withCtx(() => [
        _createVNode(esHealthProSearch, {
          onAfterAddingPwr: _cache[1] || (_cache[1] = ($event: any) => (reload()))
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_dropdownBox, {
      modelValue: dropd.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
      openOn: "AddRecipient"
    }, {
      dropd: _withCtx(() => [
        _createElementVNode("div", {
          class: "bg-modal",
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
          style: {"padding":"0"}
        }, [
          _createVNode(_component_dbGroup, null, {
            default: _withCtx(() => [
              _createVNode(_component_list_group, {
                class: "w-full",
                styles: "pad-m",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (dropd.value = 'AddPrivatePatient'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.admin.relationship.privatePatient'),
                    class: "mleft-05 font-size-14"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_list_group, {
                class: "w-full",
                styles: "pad-m",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (dropd.value = ''))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.admin.relationship.privateCustom'),
                    class: "mleft-05 font-size-14"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_list_group, {
                class: "w-full",
                styles: "pad-m",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (dropd.value = 'AddHealthPro'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.admin.relationship.healthPro'),
                    class: "mleft-05 font-size-14"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_button_group, {
          styles: "pad-s",
          class: "mleft-04"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "plus",
              styles: "main-l",
              style: {"margin-top":"-0.1rem"}
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})